import axios from 'axios'
import {CRIAR_MAPA_VEICULO} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function cadastrarMapaVeiculo(parametros) {
    const url = `${URL}/mapas-veiculos/criar`;
    return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CRIAR_MAPA_VEICULO,
            payload: response
        })
    );
}
